// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__zBfn4","value":"Counter_value__dQ4bE"};